import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const fetchProducts = createAsyncThunk(
  "product/fetchProducts",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(endPoint.GETALLPRODUCT);
      return response.data;
    } catch (error) {
      console.log("error", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const AllProductSlice = createSlice({
  name: "AllData",
  initialState: {
    AllData: [],
    error: null,
  },
  reducers: {
    clearAllProducts: (state) => {
      state.AllData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.AllData = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearAllProducts } = AllProductSlice.actions;
export default AllProductSlice.reducer;
